import { render } from "./HorseTable.vue?vue&type=template&id=2499fd78"
import script from "./HorseTable.vue?vue&type=script&lang=js"
export * from "./HorseTable.vue?vue&type=script&lang=js"

import "./HorseTable.vue?vue&type=style&index=0&id=2499fd78&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__